import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import NavigationBar from '../../ReusableComp/NavigationBar';
import { PIFlowLeftNavBar } from '../../ReusableComp/NavBarLeft';
import { Col, Container, Row, Table } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { getRejectedEventsList, getEventDetails } from '../../../Redux/actions/actions';
import { useNavigate, useLocation } from "react-router";
import moment from 'moment';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { height } from '@mui/system';
import PopUpModal from "../../ReusableComp/PopUpModal";


function PIRejectedEvents() {
    const navigate = useNavigate();
  const dispatch = useDispatch();
  const [sendData, setSendData] = useState("")
  const [searchText, setSearchText] = useState('');
  let [loading_flag, setloading_flag] = useState(false);
  const [asc,setAsC]=useState(false);
  const [desc,setDesc]=useState(false);

  const eventDtls = useSelector((state) => state.eventDtls)

  let rejectedEventsList = useSelector((state) => state.rejectedEventsList);
  const location = useLocation();
    useEffect(() => {

      if(location.state !== null && rejectedEventsList !== null){
        handleRespond(location.state?.data);
        navigate({ state: null });
      }
      setloading_flag(true);
        if(!localStorage.getItem("login_user_name")){
            navigate("/");
        }
        // dispatch(getRejectedEventsList({
        //     pi_id: localStorage.getItem("pi_id")
        // }))
        disableBackButton();
        if (eventDtls !== null && sendData !== "" && !open1) {
          // Navigate to the desired page once eventDtls is available
          navigate('/pirejectedeventsedit', {
            state: {
              data: sendData,
              eventDtls: eventDtls
            }
          });
        }
        
        if (rejectedEventsList) {
          setFilteredData(rejectedEventsList)
          setTimeout(() => {
            setloading_flag(false);
          }, 600);
        }
        if (localStorage.study_id === undefined) {
          setloading_flag(false)
        }
    }, [dispatch, eventDtls, navigate,localStorage.study_id, rejectedEventsList !== null]);
    
    useEffect(() => {
      if (rejectedEventsList) {
        setFilteredData(rejectedEventsList)
      }
    },[rejectedEventsList])

    function disableBackButton() {
        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', function(event) {
          window.history.pushState(null, null, window.location.pathname);
        });
      }
      const handleStudyChange = () => {
      
      }
      const [open1, setOpen1] = useState(false)

    const alreadyAttended = ()=>{
      setOpen1(false)
      window.location.reload()
        // alert("The event has already been attended to!")
        return;
    }
    const handleRespond = (data) => {
      if(!(rejectedEventsList?.find(item => (item.subject_id === data.subject_id)))){
      
        setOpen1(true)
        setloading_flag(false)
        
      }
      if(!open1){
        dispatch(getEventDetails(data));

      }
      setSendData(data)
    }
    const [filteredData, setFilteredData] = useState([]);

    const handleSearchData = (event) => {
      const searchText = event.target.value.toLowerCase();
      setSearchText(searchText);
      const filteredData = rejectedEventsList?.filter((item) => {
          // Convert relevant properties to lowercase for case-insensitive search
          return (
              item.subject_code && item.subject_code.toLowerCase().includes(searchText.toLowerCase())
            );
      });
      // Update the table or do whatever you want with the filteredData
      if(searchText === ""){
        setFilteredData(rejectedEventsList)
      }
      else{
        setFilteredData(filteredData)
      }
      

  }

 
  const handleAscending = () => {
    setAsC(true);
    setDesc(false);
  
    const sortedData = [...filteredData];  
    sortedData.sort((a, b) => {
      const subjectCodeA = a.subject_code;
      const subjectCodeB = b.subject_code;
      return subjectCodeA.localeCompare(subjectCodeB);
    });
    setFilteredData(sortedData);
  };
  
  const handleDescending = () => {
    setDesc(true);
    setAsC(false);
  
    const sortedData = [...filteredData];
  
    sortedData.sort((a, b) => {
      const subjectCodeA = a.subject_code;
      const subjectCodeB = b.subject_code;
      return subjectCodeB.localeCompare(subjectCodeA);
    });
    setFilteredData(sortedData);
  };
  
  const spanStyles = {
    fontSize: '14px',
    fontWeight: 600,
    marginTop: window.innerWidth > 768 ? '0' : '0', // Apply marginTop only on smaller screens
    paddingLeft: window.innerWidth > 768 ? '75px' : '15px', // Apply paddingLeft only on larger screens
  };
  const handleClosePopup = ()=>{
      setOpen1(false)
  }
  return (
    <div>
            <NavigationBar title={'Event Clarifications'} handleFilteredData={handleStudyChange}/>
            {/* <PIFlowLeftNavBar /> */}

            <div className='main_body ' style={{overflow:"hidden"}}>
            <PopUpModal
                handleClose={handleClosePopup}
                open={open1}
                title={"Success!"}
                msg={"Event has already been attended to!"}
                close={"Close"}
                actionbtn={"Done"}
                onConfirm={alreadyAttended}
              />
                <Container fluid className="pitable_container mt-2 p-2 mb-sm-4">
                <Row className='searchbar mt-0'>
                  <Col className='searchFiled gap-2 gap-md-3'>
                    {/* onChange={handleSearchData}........value={searchText}.............. onClick={exportToExcel} */}
                    <input type="text" value={searchText} placeholder='Search with Subject ID' onChange={handleSearchData} style={{ width: '400px' }} />
                    <div className=" ">
                     
                    </div>

                  </Col>
                </Row>
  
                <div>
                            {loading_flag  ? (
                                <div className=''>
                                <img
                                  className="atrium_loader_pirej"
                                  src="/images/circle-effect-loading.gif"
                                  alt="Loader"
                         
                                />
                              </div>
                            ) : (
                            <div className="table-scroll-container " style={{border:"1px solid #E1E5E7 "}}>
                              {rejectedEventsList?.length > 0 || filteredData?.length > 0  ?
                                <Table bordered size="sm" className="pitable rejeventtblmbl mb-0">
                                  <thead className='sticky_table_header'>
                                    <tr>
                                      <th> S.No</th>
                                      <th className='sticky-header'>
                                      <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                                                        <span style={spanStyles}>Subject ID</span>
                                                        <svg width="30" height="30" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" style={{float:"right"}}>
                                                                <g id="icon_sort">
                                                                    <path id="icon" d="M13.3471 21.1433C13.1481 21.4277 12.7269 21.4277 12.5279 21.1433L8.23821 15.0152C8.00624 14.6839 8.24332 14.2285 8.64783 14.2285H17.2272C17.6317 14.2285 17.8688 14.6839 17.6368 15.0152L13.3471 21.1433Z" fill={desc?"black":"#E1E5E7"} onClick={handleDescending} className='svg-cursor'/>
                                                                    <path id="icon_2" d="M13.3471 4.31368C13.1481 4.02932 12.7269 4.02932 12.5279 4.31368L8.23821 10.4418C8.00624 10.7732 8.24332 11.2285 8.64783 11.2285H17.2272C17.6317 11.2285 17.8688 10.7732 17.6368 10.4418L13.3471 4.31368Z" fill={asc?"black":"#E1E5E7"} onClick={handleAscending} className='svg-cursor'/>
                                                                </g>
                                                            </svg>
                                                            </div>
                                      </th>
                                      <th style={{ minWidth: "70px" }}>
                                        Dose
                                      </th>
                                      <th>
                                        Date of Resolution
                                      </th>
                                      <th style={{ minWidth: "70px" }}>
                                        Adverse Event
                                      </th>
                                      <th style={{ minWidth: "70px" }}>
                                        Serious Adverse Criteria
                                      </th>
            
                                      <th>Action</th>
                                    </tr>
                                  </thead>
                            
                                  <tbody className="tableBodyScroll">
                                    {filteredData && filteredData?.map((i, index) => {
                                        const numbersArray = i.subject_code.split('/').filter(item => item.trim() !== '');
                                        let lastNumber=[]
                                        if (numbersArray.length > 0) {
                                            lastNumber = numbersArray[numbersArray.length - 1];
                                                            }
                                      return (
                                        
                                        <tr key={i.index} className='text_left_table'>
                                                                                 
                                           <td className='text_right_sno'> {index + 1} </td>
                                          <td >{lastNumber}</td>
                                          <td>{i.subject_code ? i.subject_code :"-"}</td>
                                          <td>{i.dose ? "D"+i.dose :"-"}</td>
                                          <td className='text-center'>{i.date_of_resolution ? moment(i.date_of_resolution).format("DD-MM-YYYY"):"-"}</td>
                                          {/* <td>{i.adverse_event_name}</td> */}
                                          <td onClick={() => handleRespond(i)}>
                                          {i.adverse_event_name? i.adverse_event_name : "-"}
                                          <img className='tblrightarrowmbl' src="./images/icons/down_arrow.svg" alt="" />
                                          </td>
                                          <td>{i.serious_adverse_event_name?i.serious_adverse_event_name:'-'}</td>
                                          <td className="viewbtnstyl">
                                            <button className="gray_btn px-3" onClick={() => handleRespond(i)}>
                                                Respond
                                            </button>
                                          </td> 
                                          {/* <td className=' mb-0 align-items-center viewbtnstylmbl' onClick={() => handleRespond(i)}>
                                        
                                          <h3 className='mb-0'>{">"}</h3>
                                          </td> */}
                                        
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                 
                                </Table>
                                : rejectedEventsList === null && localStorage.study_id ? <div className=''>
                                <img
                                    className="atrium_loader"
                                    src="/images/circle-effect-loading.gif"
                                    alt="Loader"
            
                                />
                              </div> :
                                <div className="table-scroll-container">
                                <Table bordered size="sm" className="pitable rejeventtblmbl mb-0">
                                <thead>
                                  <tr>
                                    <th> S.No</th>
                                    <th>
                                      Subject ID
                                    </th>
                                    <th style={{ minWidth: "145px" }}>
                                      Dose
                                    </th>
                                    <th>
                                      Date of Resolution
                                    </th>
                                    <th style={{ minWidth: "70px" }}>
                                      Adverse Event
                                    </th>
                                    <th style={{ minWidth: "70px" }}>
                                      Serious Adverse Criteria
                                    </th>
            
                                    <th>Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                <tr>
                                {/* for mobile */}
                                <td colSpan="7" className="bg-white border py-4 text-center " > 
                                No records found
                                </td>
                                 {/* for mobile */}
                                  <td colSpan="7" className="bg-white border py-4 text-center " >
                                    No records found
                                  </td>
                                </tr>
                                </tbody>
                                 </Table>
                            
                              </div>
                              
                              }
                            </div>
                            )}
                        </div>
              </Container>
            </div>
        </div>
  )
}

export default PIRejectedEvents
